







































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Picker, Popup, Toast, Field } from 'vant';
import { rule } from '../submit';
import { field } from '../submit';
import Uploader from '@/components/next/NewUploader.vue';
import { save, getUserList } from '../api';
import { FileType } from '@/common/ts/enum';
import SlideVerify from '@/components/next/SlideVerify.vue';
import { isWeiXin } from '@/common/ts/common';
import { unionIdIsBind } from '@/api/api';
import qs from 'qs';

Vue.use(Picker)
  .use(Popup)
  .use(Toast)
  .use(Field);
@Component({
  components: {
    Uploader,
    SlideVerify,
  },
})
export default class Save extends Vue {
  maxTime = '60秒';
  Video = FileType.Video;
  list = rule;
  field = field;
  showPicker: boolean = false;
  pickerTile = '';
  columns = [];
  value = '';
  imageMaxSize = 10;
  imageMinSize = 0;
  maxImage = 3;
  countyList = [];
  // allow = true;
  unionid: string | null = '';
  treatextname = '创意说明';
  treatextmust = 1;
  introduction: string = '';
  introduction1: string = '';
  introduction2: string = '';
  detailcontent: string = '';
  textarea2: boolean = false;
  textarea1: boolean = false;
  showtextarea: boolean = true;
  async mounted() {
    this.field['work_type'] = '海报类';
    this.unionid = window.localStorage.getItem('unionid');
    const token = window.gettoken();
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (!token && window.udid) {
      this.AppLogin();
    }
    this.checkIsBind();
  }
  addTextBtn() {
    if (!this.textarea1 && !this.textarea2) {
      this.introduction1 = '';
      this.textarea1 = true;
    } else if (!this.textarea2 && this.textarea1) {
      this.introduction2 = '';
      this.showtextarea = false;
      this.textarea2 = true;
    }
  }
  closeText() {
    if (this.textarea1 && !this.textarea2) {
      this.introduction1 = '';
      this.textarea1 = false;
    } else if (this.textarea2 && this.textarea1) {
      this.introduction2 = '';
      this.showtextarea = true;
      this.textarea2 = false;
    }
  }
  async checkIsBind() {
    const data = {
      type: 2,
      unionId: this.unionid,
    };
    if (window.udid) {
      this.AppLogin();
    } else if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res.data) {
        this.$router.push(
          `/BindPhone?url=${encodeURIComponent(location.href)}`,
        );
        return false;
      } else {
        return true;
      }
    }
  }
  async openPicker(data: any) {
    console.log('dataaaaa:', data);
    this.columns = data.columns;
    this.pickerTile = data.title;
    this.showPicker = true;
    this.value = data.value;
  }
  onConfirm(value: any, index: any) {
    this.showPicker = false;
    this.field[this.value] = value;
    if (value === '海报类') {
      this.treatextmust = 1;
      this.treatextname = '创意说明';
    } else if (value === '宣传标语类') {
      this.treatextmust = 2;
      this.treatextname = '宣传标语';
    } else if (value === '创意文案类') {
      this.treatextmust = 3;
      this.treatextname = '创意文案';
    } else {
      this.treatextmust = 0;
      this.treatextname = '简介';
    }
    this.detailcontent = '';
    this.introduction1 = '';
    this.textarea1 = false;
    this.introduction2 = '';
    this.textarea2 = false;
    this.showtextarea = true;
  }
  onCancel() {
    this.showPicker = false;
  }
  async getCover() {
    this.field.cover = (await (this.$refs
      .uploaderImage as any)[0].uploadToOss()) as string[];
  }
  async submit() {
    // if (!this.allow) {
    //   Toast.fail('请求提交中...');
    //   return false;
    // }
    // this.allow = false;
    // setTimeout(() => {
    //   this.allow = true;
    // }, 2000);
    this.list.map((item: any) => {
      if (item.require && !this.field[item.value]) {
        Toast.fail(item.placeholder);
        throw new Error('错误');
      }
      if (item.reg && !item.reg.test(this.field[item.value])) {
        Toast.fail('电话号码格式错误');
        throw new Error('错误');
      }
      if (item.max) {
        if (this.field[item.value].length > item.max) {
          Toast.fail(item.label + '字数不能超过' + item.max + '个字');
          throw new Error('错误');
        }
      }
      if (this.treatextmust === 1) {
        if (!this.detailcontent) {
          Toast.fail('请输入创意说明');
          throw new Error('错误');
        }
        if (this.detailcontent.length > 200) {
          Toast.fail('创意说明字数不能超过200个字');
          throw new Error('错误');
        }
        if (this.field.cover.length === 0) {
          Toast.fail('请上传图片后点击下方‘上传’按钮');
          throw new Error('错误');
        }
      } else if (this.treatextmust === 2) {
        if (this.detailcontent.length > 300) {
          Toast.fail('创意说明字数不能超过300个字');
          throw new Error('错误');
        }
        if (!this.introduction) {
          Toast.fail('请输入宣传标语');
          throw new Error('错误');
        }
        if (this.introduction.length > 50) {
          Toast.fail('宣传标语不能超过50个字');
          throw new Error('错误');
        }
        if (this.textarea1) {
          if (this.introduction1 && this.introduction1.length > 50) {
            Toast.fail('宣传标语第二条不能超过50个字');
            throw new Error('错误');
          }
        }
        if (this.textarea2) {
          if (this.introduction2 && this.introduction2.length > 50) {
            Toast.fail('宣传标语第三条不能超过50个字');
            throw new Error('错误');
          }
        }
      } else if (this.treatextmust === 3) {
        if (!this.introduction) {
          Toast.fail('请输入创意文案');
          throw new Error('错误');
        }
        if (this.introduction.length > 500 || this.introduction.length < 300) {
          Toast.fail('创意文案字数最少300字最多500字');
          throw new Error('错误');
        }
        if (this.textarea1) {
          if (
            this.introduction1 &&
            (this.introduction1.length > 500 || this.introduction1.length < 300)
          ) {
            Toast.fail('创意文案第二条字数最少300字最多500字');
            throw new Error('错误');
          }
        }
        if (this.textarea2) {
          if (
            this.introduction2 &&
            (this.introduction2.length > 500 || this.introduction2.length < 300)
          ) {
            Toast.fail('创意文案第三条字数最少300字最多500字');
            throw new Error('错误');
          }
        }
      }
    });
    this.field.udid = window.udid;
    this.field.appkey = window.appkey;
    this.field.unionid = localStorage.getItem('unionid');
    //     introduction: string = '';
    // detailcontent: string = '';
    this.field.introduction = this.introduction;
    this.field.introduction1 = this.introduction1;
    this.field.introduction2 = this.introduction2;
    this.field.detailcontent = this.detailcontent;
    // this.field.unionid = 'oGN7AjkZmK0rKbC6H4O0tsKRMpZU';
    if (this.field.cover.length > 0) {
      if (this.field.cover instanceof Array) {
        this.field.cover = this.field.cover.join('|');
      }
    }
    this.fSlideData();
  }
  async fSlideData() {
    // this.showSlideVerify = false;
    // const lastData = Object.assign(res, this.field);
    const ret: any = await save(this.field);
    if (ret.code === 200) {
      Toast.success(ret.msg);
      this.field.name = '';
      this.field.work_type = '';
      this.field.author_name = '';
      this.field.phone = '';
      this.field.sch_name = '';
      this.field.addr_detail = '';
      this.field.introduction = '';
      this.field.cover = [];
      setTimeout(() => {
        // this.$router.go(0);
      }, 2000);
      this.$router.push('user');
    } else {
      Toast.fail(ret.msg);
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
